<template>
  <div class="body_right">
    <div class="body_right_first">
      <div class="img"><img src="../../../../assets/imgs/icon_open.png"></div>
      <div class="title">お知らせ</div>
    </div>
    <div class="body_right_second">
      <div class="body_right_second_scrollbar">
        <system-notice-item v-for="(item,index) in list" :key="index" :data="item"></system-notice-item>
      </div>
    </div>
  </div>
</template>

<script>
import systemNoticeItem from '@/components/systemNoticeItem/index'
  export default {
    components: {
      systemNoticeItem
    },
    data () {
      return {
        list: [{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        },{
          id: 1,
          time: '2022/12/29 12:00',
          title: '英雄同盟S 8応援活動が全面的にスタート！',
          content: '勝利に乾杯、S 8を応援！6日の生中継室をロックして、すばらしい試合の原画を展示して、豊富な活動 はあなたが参加することを待っ->https://live.bilibili.com',
        }]
      }
    },
    created () {
    },
    methods: {
      
    }
  }
</script>

<style src="@/pages/homePage/notice/likeNotice/index.css" scoped>
</style>

